"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reduxOidc = require("redux-oidc");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _SSOCallbackContainer = _interopRequireDefault(require("./SSOCallbackContainer"));
var routes = _interopRequireWildcard(require("../constants/routes"));
var ssoActions = _interopRequireWildcard(require("../actions/ssoActions"));
var userSelector = _interopRequireWildcard(require("../selectors/userSelector"));
var sessionSelector = _interopRequireWildcard(require("../selectors/sessionSelector"));
var configuration = _interopRequireWildcard(require("../constants/configuration"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SSOValidationContainer = function SSOValidationContainer(_ref) {
  var children = _ref.children,
    store = _ref.store,
    userManager = _ref.userManager,
    history = _ref.history,
    user = _ref.user,
    userExpired = _ref.userExpired,
    logoutUser = _ref.logoutUser,
    hasSessionClaims = _ref.hasSessionClaims,
    isLoadingSessionClaims = _ref.isLoadingSessionClaims,
    isAuthorizedForUfgAgent = _ref.isAuthorizedForUfgAgent,
    applicationId = _ref.applicationId,
    validateRouteAuthentication = _ref.validateRouteAuthentication,
    logoutAndRedirect = _ref.logoutAndRedirect,
    agentUnauthorizedAndRedirect = _ref.agentUnauthorizedAndRedirect,
    clientType = _ref.clientType;
  var validateRouteAndSession = function validateRouteAndSession() {
    if (!userExpired) {
      validateRouteAuthentication(user);
    } else {
      logoutAndRedirect(logoutUser);
    }
  };
  var validateAuthorized = function validateAuthorized() {
    var isAgentClientTypeUnauthorized = clientType === configuration.CLIENT_TYPE_AGENT && !isAuthorizedForUfgAgent;
    if (user && hasSessionClaims && isAgentClientTypeUnauthorized) {
      agentUnauthorizedAndRedirect(applicationId);
    }
  };
  var isAuthorizedForContent = function isAuthorizedForContent(user, hasSessionClaims, clientType, isAuthorizedForUfgAgent) {
    return user && hasSessionClaims && (clientType !== configuration.CLIENT_TYPE_AGENT || clientType === configuration.CLIENT_TYPE_AGENT && isAuthorizedForUfgAgent);
  };
  (0, _react.useEffect)(function () {
    validateRouteAndSession();
    validateAuthorized();
  }, [validateRouteAndSession, validateAuthorized]);
  var renderSSOCallback = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react["default"].createElement(_SSOCallbackContainer["default"], {
      userManager: userManager,
      history: history
    });
  }, [userManager, history]);
  return /*#__PURE__*/_react["default"].createElement(_reduxOidc.OidcProvider, {
    store: store,
    userManager: userManager
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: routes.OIDC_SSO_CALLBACK,
    render: renderSSOCallback
  }), isAuthorizedForContent(user, hasSessionClaims, clientType, isAuthorizedForUfgAgent) && children, isLoadingSessionClaims && /*#__PURE__*/_react["default"].createElement("div", null, "Loading profile...")));
};
SSOValidationContainer.propTypes = {
  children: _propTypes["default"].element.isRequired,
  store: _propTypes["default"].object,
  userManager: _propTypes["default"].object.isRequired,
  history: _propTypes["default"].object.isRequired,
  user: _propTypes["default"].object,
  userExpired: _propTypes["default"].bool,
  logoutUser: _propTypes["default"].object,
  hasSessionClaims: _propTypes["default"].bool,
  isLoadingSessionClaims: _propTypes["default"].bool,
  isAuthorizedForUfgAgent: _propTypes["default"].bool,
  applicationId: _propTypes["default"].string,
  validateRouteAuthentication: _propTypes["default"].func.isRequired,
  logoutAndRedirect: _propTypes["default"].func.isRequired,
  agentUnauthorizedAndRedirect: _propTypes["default"].func.isRequired,
  clientType: _propTypes["default"].string.isRequired
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var specialtyEnabled = ownProps.specialtyEnabled;
  return {
    user: userSelector.getOpenIDUser(state),
    userExpired: sessionSelector.isUserExpired(state),
    logoutUser: sessionSelector.getLogoutUser(state),
    hasSessionClaims: sessionSelector.hasSessionClaims(state),
    isLoadingSessionClaims: sessionSelector.isLoadingSessionClaims(state),
    applicationId: sessionSelector.getApplicationId(state),
    isAuthorizedForUfgAgent: sessionSelector.isAuthorizedForUfgAgent(state, specialtyEnabled)
  };
};
var mapDispatchToProps = {
  validateRouteAuthentication: ssoActions.validateRouteAuthentication,
  logoutAndRedirect: ssoActions.logoutAndRedirect,
  agentUnauthorizedAndRedirect: ssoActions.agentUnauthorizedAndRedirect
};
var _default = exports["default"] = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SSOValidationContainer));